<template>
    <div  id='cust_component' class="footer fixed-bottom" :class= " (footer_type == 'ash_bg') ? 'box_shadow bg-ash': ((footer_type == 'green_bg') ? 'bg-green' : 'bg-blue')">
        <div class="container-fluid">
            <div class="row">
                <div v-if="footer_content_type == 'text_justify'" class="col-11 col-xl-5 col-lg-6 col-sm-10 col-md-7 m-auto p-0">
                    <p :class="(footer_type == 'ash_bg') ? '' : 'white'">
                        <span class="pull-left">
                            <b v-if="total_cart_services == 1">{{total_cart_services}} Service</b>
                            <b v-else>{{total_cart_services}} Services</b>

                            <span v-if="total_cart_products > 0">
                                <b> & </b>
                                <b v-if="total_cart_products == 1">{{total_cart_products}} Product</b>
                                <b v-else>{{total_cart_products}} Products</b>
                            </span>
                        </span>

                        

                        <span class="pull-right point_cursor">
                            <button class=" btn btn-md btn-rounded btn-pink footer_button" @click="on_continue">
                                <b v-if="location_path == '/addproducts' && total_cart_products == 0">Skip & Continue</b>
                                <b v-else>Continue</b>
                            </button>
                        </span>
                    </p>
                </div>

                <div v-if="footer_content_type == 'text_center' " class="col-11 col-xl-5 col-lg-6 col-sm-10 col-md-7 m-auto p-0">
                    <p v-if="footer_type == 'ash_bg'" class="text-center" :class="text_color" @click="on_continue"><b>{{footer_text}}</b></p>
                    <p v-else class="white text-center point_cursor" @click="on_continue"><b>{{footer_text}}</b></p>
                </div>


                <div v-if="footer_content_type == 'button_center' " class="col-11 col-xl-5 col-lg-6 col-sm-10 col-md-7 m-auto p-0 text-center">
                   <p><button class="btn btn-md btn-rounded  footer_button" :class="btn_bg"  @click="on_back">{{footer_text}}</button></p>
                </div>

                <div v-if="footer_content_type == 'buttons' " class="col-11 col-xl-5 col-lg-6 col-sm-10 col-md-7 m-auto p-0">
                    <p> 
                       <span class="pull-left"><button class="btn btn-md btn-rounded  footer_button"  :class="btn_bg"  @click="on_back">{{first_footer_text}}</button></span>
                       <span  class="pull-right"><button class="btn btn-md btn-rounded footer_button"  :class="second_btn_bg"   @click="on_continue">{{second_footer_text}}</button></span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .footer{
        height: 60px;
    }

    .footer p{
        line-height: 58px;
    }

    .footer_button{
        padding: 0.375rem 1.75rem;
    }
</style>

<script>
    export default {
        name: 'custFooter',
        props:{
            footer_type : String,
            service_number : Number,
            products_number : Number,
            classes_number : Number,
            footer_text : String,
            footer_content_type : String,
            total_cart_services : Number,
            total_cart_products: Number,
            text_color: String,
            btn_bg : String,
            second_btn_bg: String,
            second_footer_text:String,
            first_footer_text: String
        },
        data(){
            return {
                location_path : '',
            }
        },
        mounted(){
            this.location_path = window.location.pathname;
        },
        methods:{
            on_continue(){
                this.$emit('continue_function');
            },
            on_back(){
                this.$emit('back_function');
            }
        }
    }
</script>